import { styled } from '@linaria/react';
import { breakpoints, fonts, space } from '../../theme/tokens';

export const Row = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: calc(${space['space-1200']} + ${space['space-200']});

  & > button {
    left: 0;
  }

  & > div > button {
    font-size: ${fonts.size.base};
  }

  @media (max-width: ${breakpoints.tablet}) {
    &[data-active-step='dates'] > div > :nth-child(n + 2) {
      display: none;
    }

    &[data-active-step='guests'] > div > :nth-child(-n + 2) {
      display: none;
    }
  }
`;
